import { render, staticRenderFns } from "./DetallesCovid.vue?vue&type=template&id=1559e0a0&"
import script from "./DetallesCovid.vue?vue&type=script&lang=js&"
export * from "./DetallesCovid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports